/* this map is used to determine the next percentage of active cubes based
 * on the current percentage of inactive cubes to achieve a smooth, infinite, auto animation.
 * todo: refactor with a state machine
 */
export const INACTIVE_TO_ACTIVE_CUBE_TRANSITIONS = {
  100: 20,
  80: 50,
  50: 10,
  90: 20,
};

export const getNextActiveCubePercentage = (
  currentInactivePercentage: keyof typeof INACTIVE_TO_ACTIVE_CUBE_TRANSITIONS,
) => {
  return INACTIVE_TO_ACTIVE_CUBE_TRANSITIONS[currentInactivePercentage];
};
